
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/empty-wallet"}},[_c('path',{attrs:{"d":"M4.167 21.933a1.25 1.25 0 01-1.25-1.25v-7.617a5.958 5.958 0 013.874-5.619l13.234-5A4.417 4.417 0 0126 6.583v6.333a1.25 1.25 0 11-2.5 0V6.583a1.917 1.917 0 00-2.59-1.8l-13.235 5a3.477 3.477 0 00-2.258 3.283v7.617a1.25 1.25 0 01-1.25 1.25z","fill":"#090A0A"}}),_c('path',{attrs:{"data-name":"Vector","d":"M23.334 21.25H11.667a1.25 1.25 0 010-2.5h11.667a1.25 1.25 0 010 2.5z","fill":"#090A0A"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.434 11.667h19.133a7.525 7.525 0 017.517 7.517v2.4a1.25 1.25 0 01-1.25 1.25h-3.367a2.077 2.077 0 00-1.5.622l-.022.022a2.1 2.1 0 00-.629 1.7v.015a2.315 2.315 0 002.351 1.974h3.167a1.25 1.25 0 011.25 1.25V30.4a7.525 7.525 0 01-7.517 7.517H10.434A7.525 7.525 0 012.917 30.4V19.184a7.525 7.525 0 017.517-7.517zm24.15 8.667v-1.15a5.022 5.022 0 00-5.017-5.017H10.434a5.022 5.022 0 00-5.017 5.017V30.4a5.022 5.022 0 005.017 5.017h19.133a5.022 5.022 0 005.017-5.017v-.733h-1.917a4.8 4.8 0 01-4.845-4.256 4.684 4.684 0 014.645-5.077z","fill":"#F5CF37"}}),_c('path',{attrs:{"data-name":"Vector","d":"M32.466 20.333h3.512a2.954 2.954 0 012.873 2.95v3.433a2.954 2.954 0 01-2.873 2.949h-3.312a4.8 4.8 0 01-4.845-4.255 4.583 4.583 0 011.361-3.711 4.558 4.558 0 013.284-1.366zm3.438 2.5h-3.438a2.077 2.077 0 00-1.5.622l-.022.022a2.1 2.1 0 00-.633 1.706v.015a2.315 2.315 0 002.354 1.97h3.239a.462.462 0 00.446-.45v-3.435a.462.462 0 00-.446-.45z","fill":"#F5CF37"}})])])
          )
        }
      }
    